<template>
  <div>
    <div class="modal fade" id="add-program-modal">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Add New Program</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form @submit.prevent="addProgram">
            <div class="modal-body">
              <div class="form-group">
                <label for="program_name">Program Name *</label>
                <input
                  type="text"
                  class="form-control"
                  id="program_name"
                  v-model="form.program_name"
                  required
                />
              </div>

              <div class="form-group">
                <label for="discipline_code">Discipline Code *</label>
                <input
                  type="text"
                  class="form-control"
                  id="discipline_code"
                  v-model="form.discipline_code"
                  required
                />
              </div>

              <div class="form-group">
                <label for="level_code">Level Code *</label>
                <input
                  type="text"
                  class="form-control"
                  id="level_code"
                  v-model="form.level_code"
                  required
                />
              </div>

              <div class="form-group">
                <label for="major">Major</label>
                <input
                  type="text"
                  class="form-control"
                  id="major"
                  v-model="form.major"
                  placeholder="Optional"
                />
              </div>

              <div class="form-group">
                <label for="major_discipline_code">Major Discipline Code</label>
                <input
                  type="text"
                  class="form-control"
                  id="major_discipline_code"
                  v-model="form.major_discipline_code"
                  placeholder="Optional"
                />
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                Cancel
              </button>
              <button type="submit" class="btn btn-primary" :disabled="loading">
                <span
                  v-if="loading"
                  class="spinner-border spinner-border-sm mr-1"
                ></span>
                {{ loading ? "Adding..." : "Add Program" }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddProgramModal",
  data() {
    return {
      loading: false,
      form: {
        program_name: "",
        discipline_code: "",
        level_code: "",
        major: "",
        major_discipline_code: "",
      },
    };
  },
  methods: {
    open() {
      // Reset form
      this.form = {
        program_name: "",
        discipline_code: "",
        level_code: "",
        major: "",
        major_discipline_code: "",
      };

      $("#add-program-modal").modal("show");
    },

    addProgram() {
      this.loading = true;

      axios
        .post("/api/program/0", this.form) // Using 0 as placeholder since endpoint expects {id}
        .then((response) => {
          toastr.success(
            response.data.msg || "Program added successfully",
            "Success"
          );
          $("#add-program-modal").modal("hide");
          this.$emit("programAdded");
        })
        .catch((error) => {
          let errorMessage = "Failed to add program"; // default

          const data = error.response?.data;

          if (data) {
            // If there are validation errors, use them
            if (data.errors) {
              // Flatten all errors into a single string
              const messages = Object.values(data.errors).flat();
              if (messages.length > 0) {
                errorMessage = messages.join(" and "); // or "\n" for new lines
              }
            }
            // If no errors object, fall back to message
            else if (data.message) {
              errorMessage = data.message;
            }
          }

          toastr.error(errorMessage, "Error");
        })

        .finally(() => {
          this.loading = false;
        });
    },

    close() {
      $("#add-program-modal").modal("hide");
    },
  },
};
</script>
